import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {EntityServiceClient, ExportRequestDto, RawMaterialDto} from '@sharedrest/data.restservice';
import {UserService} from '@sharedcommon/services/user.service';
import {Rights} from '@sharedcommon/util/rights.util';
import {NeqDialogService} from '@sharedcommon/services/dialog.service';
import {ToastService} from '@sharedcommon/services/toast.service';
import { RawmaterialOrSampleService } from '@usercommon/service/rawmaterial-or-sample.service';
import { CalculationStatusService } from './calculation-status.service';
import { SampleDto } from '@sharedcommon/model/sample/sample.model';
import {RawmaterialOrSampleStatus} from '@sharedcommon/util/rawmaterial-or-sample-status.utils';

@Injectable()
export class ExportService {

  constructor(private readonly translate: TranslateService,
              private readonly userService: UserService,
              private readonly rawMatNutStore: RawmaterialOrSampleService,
              private readonly dialogService: NeqDialogService,
              private readonly toaster: ToastService,
              private readonly entityService: EntityServiceClient
  ) {
  }

  isComputeCalcStatusValidAndForced(): boolean {
    const computeCalcStatus = this.rawMatNutStore.getTempCalculationStatus() ;
    return CalculationStatusService.isCalcStatusValid(computeCalcStatus)
              && this.rawMatNutStore.getTempForcedCalcStatus()
              && !!this.rawMatNutStore.getCalculationId() ;
  }


  canExport(rawMaterial: RawMaterialDto|SampleDto): boolean {
    const currentCalcStatus = this.rawMatNutStore.getCurrentCalculationStatus() ;
    const isCalcStatusMatched = !(
                                    CalculationStatusService.isCalcStatusBlockedAfterCalc(currentCalcStatus)
                                    || CalculationStatusService.isCalcStatusBlockedBeforeCalc(currentCalcStatus)
                                    || this.isComputeCalcStatusValidAndForced()
                                  );
    return this.userService.isFeedOperatingMode() && isCalcStatusMatched
                && rawMaterial?.calculationDate
                && rawMaterial?.status == RawmaterialOrSampleStatus.ENABLED
                && this.userService.hasRights([Rights.U_MP_EXPORT])
                && this.exportEnabled();
  }


  returnExportTooltip(): string {
    const key: string =  this.isComputeCalcStatusValidAndForced() ?
                                'msg.common.icon.rawmaterial.results.export.save-before'
                                : 'msg.common.icon.rawmaterial.results.export'
    return this.translate.instant(key);
  }

  exportEnabled(): boolean {
    return this.userService.isFeedOperatingMode() && this.userService.getEntityDto().rawmatExportEnabled && this.userService.hasRights([Rights.U_MP_EXPORT]);
  }

  exportRequest(rawMaterial: RawMaterialDto) {
    if (!this.canExport(rawMaterial)) {
      return;
    }

    const confirmationMessage = this.translate.instant('label.user.export.confirmation.single', {
      rawMaterial: `${rawMaterial.code} - ${rawMaterial.label}`,
      format: `${this.userService.getEntityDto().rawmatExportFormat}`
    });

    this.dialogService.showConfirmation(confirmationMessage).afterClosed().subscribe(result => {
      if (result) {
        const request: ExportRequestDto = {
          refreshToken: 'DEPRECATED',
          rawMaterialsCodes: [{entityCode: rawMaterial.entity.identifier, rmCodes: [{rmCode: rawMaterial.code}]}]
        };

        this.entityService.rawMaterialsexportnotificationExportNotification(this.userService.getEntity(), request).subscribe(() => {
          this.toaster.toast(this.translate.instant('label.user.export.request-successful'));
        });
      }
    });
  }
}
